
  import { css } from 'lit';
  export const styles = css`:host{color:var(--header-text-color)}::slotted([slot=subtitle]){color:var(--subtitle-text-color)}`;
  